import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { SESSION_URLS } from "../../api/AdminUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { post } from "../../services/smartApiService";
import SessionUsersTable from "./SessionUsersTable";
import CardsGrid from "./CardsGrid";
import {
  changeDateTimeFormat,
  changeDateTimeZone,
} from "../../services/core/CommonService";
import { formatUnixTimestamp } from "../../services/core/DateService";
import { checkInterSection } from "../../services/core/FilterService";
import "./sessions.scss";

interface HeaderProps {
  idIn?: number;
}
const SessionDetails: React.FC<HeaderProps> = ({ idIn }) => {
  const { id } = useParams<{ id: any }>();
  const [_data, setTabData] = useState<any>();
  const navigate = useNavigate();
  const { setTitle, user } = useSiteContext();
  const is_admin = checkInterSection(user?.roles || [], ["ADMIN", "AGENCY"]);
  const loadData = () => {
    let URL = SESSION_URLS.GET_ONE;
    const subscription = post(URL, { id: idIn ? idIn : id }).subscribe(
      (response) => {
        setTabData(response.data);
        console.log("text data", response.data);
        if (!idIn) {
          setTitle(response.data?.session_id);
        }
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  };
  useEffect(() => {
    loadData();
    if (!idIn) {
      setTitle("Session Details");
    }
  }, []);

  const startSession = () => {
    let URL = SESSION_URLS.SESSION_START;
    const subscription = post(URL, { id: id }).subscribe((response) => {
      navigate("/admin/dashboard-trainer");
    });
    return () => {
      subscription.unsubscribe();
    };
  };
  const isToday = (dateString: string | undefined): boolean => {
    if (!dateString) return false;

    const today = new Date();
    const sessionDate = new Date(dateString);

    return (
      sessionDate.getDate() === today.getDate() &&
      sessionDate.getMonth() === today.getMonth() &&
      sessionDate.getFullYear() === today.getFullYear()
    );
  };

  return (
    <div className="">
     <div className="table-container">
  <table className="table is-fullwidth responsive-table">
    <tbody>
      <tr>
        <th>Agency Name</th>
        <td>{_data?.agency_name}</td>
        <th>Project Name</th>
        <td>{_data?.project_name}</td>
        <th>Venue</th>
        <td>{_data?.location}</td>
      </tr>
      <tr>
        <th>Session Date</th>
        <td>
          {changeDateTimeZone(_data?.session_date)} to{" "}
          {changeDateTimeZone(_data?.session_to_date)}
        </td>
        <th>Status</th>
        <td>{_data?.status}</td>
      </tr>
    </tbody>
  </table>
</div>


      {/* Results Table can be displayed when it is completed */}
      <div className="">
        {" "}
        <CardsGrid data={_data} />
      </div>

      <SessionUsersTable
        session_id={idIn ? idIn : id}
        idIn={idIn}
        status_data={_data}
      />

      <div className="has-text-centered mt-5">
        {_data?.status === "active" &&
          !is_admin &&
          isToday(_data?.session_date) && (
            <button className="button is-link mr-4" onClick={startSession}>
              Start Session
            </button>
          )}

        <button
          className="button is-danger "
          onClick={() => navigate(-1)}
        >
          Back
        </button>
      </div>
    </div>
  );
};

export default SessionDetails;
